var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.12,
    height: 10.27,
    viewBox: "0 0 17.12 10.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M5.671,13.095l-.248.257v-6.5a.856.856,0,1,0-1.712,0v6.5l-.248-.257A.859.859,0,0,0,2.248,14.31l1.712,1.712a.857.857,0,0,0,.282.18.8.8,0,0,0,.65,0,.856.856,0,0,0,.282-.18L6.886,14.31a.859.859,0,1,0-1.215-1.215ZM9.7,7.712H18.26A.856.856,0,0,0,18.26,6H9.7a.856.856,0,0,0,0,1.712Zm8.558,2.568H9.7a.856.856,0,0,0,0,1.712H18.26a.856.856,0,0,0,0-1.712Zm0,4.279H9.7a.856.856,0,0,0,0,1.712H18.26a.856.856,0,0,0,0-1.712Z",
    transform: "translate(-1.996 -6)",
    fill: "#023f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortList);
export default __webpack_public_path__ + "static/media/sort_list.7f1bd9ce67fa67ce272f1151cf15e1e5.svg";
export { ForwardRef as ReactComponent };